import { DatePipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { Setting } from '@common/interfaces/setting.interface';
import { SettingKeyCodes } from '@common/known-types/setting-key.codes';
import { environment } from '@environments/environment.base';
import { QueryService } from '@services/query.service';

@Pipe({
    name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {
    defaultDateFormat: string = environment.settings.appControl.dateFormat;
    private datePipe = inject(DatePipe);
    private queryService = inject(QueryService);

    constructor() {
        this.getDefaultDateFormat();
    }

    transform(value: Date | string): string | null {
        return this.datePipe.transform(value, this.defaultDateFormat);
    }

    private getDefaultDateFormat() {
        const settings = this.queryService.queryClient.getQueryData<Setting[]>(['settings']);
        if (!settings) return;
        const defaultDateFormat = settings.find(
            (setting: Setting) => setting.key === SettingKeyCodes.DateFormat
        )?.value;
        if (defaultDateFormat) this.defaultDateFormat = defaultDateFormat;
    }
}
